import { FC } from 'react';
import styled from 'styled-components';

const SubHeaderElement = styled.div`
  display: grid;
  grid-template-areas: 'left middle right';
  grid-template-columns: auto 1fr auto;
  grid-column-gap: 30px;
  align-items: center;
  border-top: 1px solid #dce5eb;
  border-bottom: 1px solid #dce5eb;
  padding-top: 15px;
  padding-bottom: 10px;
  flex-wrap: nowrap;

  &&&& > * > * {
    margin-right: 30px;
    word-wrap: none;
  }

  &&& > * > *:last-child {
    margin-right: 0px;
  }
`;

export const SubHeader: FC = props => {
  return <SubHeaderElement>{props.children}</SubHeaderElement>;
};
